import React, { useState } from "react";
import styled from "styled-components";

const BurgerMenu = () => {
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');

  React.useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'soluciones-hormigon', 'servicios', 'process', 'contacto'];
      const scrollPosition = window.scrollY + 120;

      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50) {
        setActiveSection('contacto');
        return;
      }

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offsetTop = rect.top + window.scrollY;
          const height = element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            setActiveSection(section);
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Bloquear scroll cuando el menú está abierto
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
    };
  }, [open]);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    setOpen(false);

    // Give a small delay for the menu to close and scroll unlock before navigating
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        const rect = element.getBoundingClientRect();
        const offsetTop = rect.top + window.scrollY - 90;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }, 10);
  };

  const whatsappUrl = "https://wa.me/5493512630050?text=" + encodeURIComponent("Hola, vi tu anuncio en la web y quisiera coordinar una visita para");

  return (
    <>
      {/* BOTÓN HAMBURGUESA */}
      <BurgerButton onClick={() => setOpen(true)}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 18C3.71667 18 3.47934 17.904 3.288 17.712C3.09667 17.52 3.00067 17.2827 3 17C2.99934 16.7173 3.09534 16.48 3.288 16.288C3.48067 16.096 3.718 16 4 16H20C20.2833 16 20.521 16.096 20.713 16.288C20.905 16.48 21.0007 16.7173 21 17C20.9993 17.2827 20.9033 17.5203 20.712 17.713C20.5207 17.9057 20.2833 18.0013 20 18H4ZM4 13C3.71667 13 3.47934 12.904 3.288 12.712C3.09667 12.52 3.00067 12.2827 3 12C2.99934 11.7173 3.09534 11.48 3.288 11.288C3.48067 11.096 3.718 11 4 11H20C20.2833 11 20.521 11.096 20.713 11.288C20.905 11.48 21.0007 11.7173 21 12C20.9993 12.2827 20.9033 12.5203 20.712 12.713C20.5207 12.9057 20.2833 13.0013 20 13H4ZM4 8C3.71667 8 3.47934 7.904 3.288 7.712C3.09667 7.52 3.00067 7.28267 3 7C2.99934 6.71733 3.09534 6.48 3.288 6.288C3.48067 6.096 3.718 6 4 6H20C20.2833 6 20.521 6.096 20.713 6.288C20.905 6.48 21.0007 6.71733 21 7C20.9993 7.28267 20.9033 7.52033 20.712 7.713C20.5207 7.90567 20.2833 8.00133 20 8H4Z" fill="white" />
        </svg>
      </BurgerButton>

      {/* OVERLAY FULLSCREEN */}
      <Overlay $open={open}>
        <CloseButton onClick={() => setOpen(false)}>×</CloseButton>

        <MenuContent>
          <MenuItem
            href="#inicio"
            className={activeSection === 'inicio' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'inicio')}
          >
            Inicio
          </MenuItem>
          <MenuItem
            href="#soluciones-hormigon"
            className={activeSection === 'soluciones-hormigon' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'soluciones-hormigon')}
          >
            Soluciones en Hormigón
          </MenuItem>
          <MenuItem
            href="#servicios"
            className={activeSection === 'servicios' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'servicios')}
          >
            Servicios de construcción
          </MenuItem>
          <MenuItem
            href="#contacto"
            className={activeSection === 'contacto' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'contacto')}
          >
            Contacto
          </MenuItem>

          <BottomSection>
            <ContentLogoSocials>
              <Logo>

                <img src="/logo.png" alt="Comber Logo" />
              </Logo>

              <Socials>
                <Circle href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.95605 6.83222C5.95605 6.95009 6.00286 7.06314 6.08617 7.14649C6.16949 7.22984 6.28248 7.27666 6.40031 7.27666C6.51813 7.27666 6.63113 7.22984 6.71444 7.14649C6.79776 7.06314 6.84456 6.95009 6.84456 6.83222V5.94333C6.84456 5.82546 6.79776 5.71241 6.71444 5.62906C6.63113 5.54571 6.51813 5.49889 6.40031 5.49889C6.28248 5.49889 6.16949 5.54571 6.08617 5.62906C6.00286 5.71241 5.95605 5.82546 5.95605 5.94333V6.83222ZM5.95605 6.83222C5.95605 8.01096 6.42411 9.14142 7.25724 9.97491C8.09038 10.8084 9.22036 11.2767 10.3986 11.2767M10.3986 11.2767H11.2871C11.4049 11.2767 11.5179 11.2298 11.6012 11.1465C11.6846 11.0631 11.7314 10.9501 11.7314 10.8322C11.7314 10.7143 11.6846 10.6013 11.6012 10.5179C11.5179 10.4346 11.4049 10.3878 11.2871 10.3878H10.3986C10.2808 10.3878 10.1678 10.4346 10.0845 10.5179C10.0011 10.6013 9.95434 10.7143 9.95434 10.8322C9.95434 10.9501 10.0011 11.0631 10.0845 11.1465C10.1678 11.2298 10.2808 11.2767 10.3986 11.2767ZM0.625 16.61L2.09104 13.2322C0.969442 11.6394 0.467438 9.6918 0.679239 7.75498C0.891039 5.81815 1.80208 4.02523 3.2414 2.71268C4.68071 1.40013 6.54935 0.658188 8.49664 0.626087C10.4439 0.593985 12.336 1.27393 13.8177 2.53833C15.2995 3.80272 16.2691 5.56464 16.5446 7.49343C16.82 9.42222 16.3825 11.3853 15.3139 13.0142C14.2454 14.6432 12.6194 15.826 10.741 16.3408C8.86267 16.8555 6.86111 16.6668 5.11197 15.81L0.625 16.61Z" stroke="#0C273C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </Circle>
                <Circle href="https://www.instagram.com/combersoluciones/" target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 1.62651C11.3855 1.62651 11.7108 1.62651 12.6867 1.62651C13.5542 1.62651 13.988 1.84337 14.3133 1.95181C14.747 2.16868 15.0723 2.27711 15.3976 2.60241C15.7229 2.92771 15.9398 3.25301 16.0482 3.68675C16.1566 4.01205 16.2651 4.44578 16.3735 5.31325C16.3735 6.28916 16.3735 6.50602 16.3735 9C16.3735 11.494 16.3735 11.7108 16.3735 12.6867C16.3735 13.5542 16.1566 13.988 16.0482 14.3133C15.8313 14.747 15.7229 15.0723 15.3976 15.3976C15.0723 15.7229 14.747 15.9398 14.3133 16.0482C13.988 16.1566 13.5542 16.2651 12.6867 16.3735C11.7108 16.3735 11.494 16.3735 9 16.3735C6.50602 16.3735 6.28916 16.3735 5.31325 16.3735C4.44578 16.3735 4.01205 16.1566 3.68675 16.0482C3.25301 15.8313 2.92771 15.7229 2.60241 15.3976C2.27711 15.0723 2.06024 14.747 1.95181 14.3133C1.84337 13.988 1.73494 13.5542 1.62651 12.6867C1.62651 11.7108 1.62651 11.494 1.62651 9C1.62651 6.50602 1.62651 6.28916 1.62651 5.31325C1.62651 4.44578 1.84337 4.01205 1.95181 3.68675C2.16868 3.25301 2.27711 2.92771 2.60241 2.60241C2.92771 2.27711 3.25301 2.06024 3.68675 1.95181C4.01205 1.84337 4.44578 1.73494 5.31325 1.62651C6.28916 1.62651 6.61446 1.62651 9 1.62651ZM9 0C6.50602 0 6.28916 0 5.31325 0C4.33735 0 3.68675 0.216868 3.14458 0.433736C2.60241 0.650603 2.06024 0.975904 1.51807 1.51807C0.975904 2.06024 0.759037 2.49398 0.433736 3.14458C0.216868 3.68675 0.108434 4.33735 0 5.31325C0 6.28916 0 6.61446 0 9C0 11.494 0 11.7108 0 12.6867C0 13.6627 0.216868 14.3133 0.433736 14.8554C0.650603 15.3976 0.975904 15.9398 1.51807 16.4819C2.06024 17.0241 2.49398 17.241 3.14458 17.5663C3.68675 17.7831 4.33735 17.8916 5.31325 18C6.28916 18 6.61446 18 9 18C11.3855 18 11.7108 18 12.6867 18C13.6627 18 14.3133 17.7831 14.8554 17.5663C15.3976 17.3494 15.9398 17.0241 16.4819 16.4819C17.0241 15.9398 17.241 15.506 17.5663 14.8554C17.7831 14.3133 17.8916 13.6627 18 12.6867C18 11.7108 18 11.3855 18 9C18 6.61446 18 6.28916 18 5.31325C18 4.33735 17.7831 3.68675 17.5663 3.14458C17.3494 2.60241 17.0241 2.06024 16.4819 1.51807C15.9398 0.975904 15.506 0.759037 14.8554 0.433736C14.3133 0.216868 13.6627 0.108434 12.6867 0C11.7108 0 11.494 0 9 0Z" fill="#0C273C" />
                    <path d="M9 4.33735C6.39759 4.33735 4.33735 6.39759 4.33735 9C4.33735 11.6024 6.39759 13.6627 9 13.6627C11.6024 13.6627 13.6627 11.6024 13.6627 9C13.6627 6.39759 11.6024 4.33735 9 4.33735ZM9 12.0361C7.3735 12.0361 5.96386 10.7349 5.96386 9C5.96386 7.3735 7.26506 5.96386 9 5.96386C10.6265 5.96386 12.0361 7.26506 12.0361 9C12.0361 10.6265 10.6265 12.0361 9 12.0361Z" fill="#0C273C" />
                    <path d="M13.7711 5.31325C14.3699 5.31325 14.8554 4.82778 14.8554 4.22892C14.8554 3.63005 14.3699 3.14458 13.7711 3.14458C13.1722 3.14458 12.6867 3.63005 12.6867 4.22892C12.6867 4.82778 13.1722 5.31325 13.7711 5.31325Z" fill="#0C273C" />
                  </svg>
                </Circle>
                <Circle href="https://www.facebook.com/profile.php?id=61587718792709" target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 9C18 4.05 13.95 0 9 0C4.05 0 0 4.05 0 9C0 13.5 3.2625 17.2125 7.5375 17.8875V11.5875H5.2875V9H7.5375V6.975C7.5375 4.725 8.8875 3.4875 10.9125 3.4875C11.925 3.4875 12.9375 3.7125 12.9375 3.7125V5.9625H11.8125C10.6875 5.9625 10.35 6.6375 10.35 7.3125V9H12.825L12.375 11.5875H10.2375V18C14.7375 17.325 18 13.5 18 9Z" fill="#0C273C" />
                  </svg>
                </Circle>
              </Socials>
            </ContentLogoSocials>

            <CTAButton
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66732 6.66634V14.6663M10.0007 3.91967L9.33398 6.66634H13.2207C13.4276 6.66634 13.6318 6.71453 13.8169 6.8071C14.0021 6.89967 14.1631 7.03408 14.2873 7.19967C14.4115 7.36527 14.4954 7.55751 14.5325 7.76116C14.5695 7.96481 14.5586 8.17429 14.5007 8.37301L12.9473 13.7063C12.8665 13.9833 12.6981 14.2266 12.4673 14.3997C12.2365 14.5728 11.9558 14.6663 11.6673 14.6663H2.66732C2.3137 14.6663 1.97456 14.5259 1.72451 14.2758C1.47446 14.0258 1.33398 13.6866 1.33398 13.333V7.99967C1.33398 7.64605 1.47446 7.30691 1.72451 7.05687C1.97456 6.80682 2.3137 6.66634 2.66732 6.66634H4.50732C4.75537 6.66621 4.99848 6.59688 5.20929 6.46615C5.4201 6.33543 5.59027 6.14848 5.70065 5.92634L8.00065 1.33301C8.31504 1.3369 8.62448 1.41179 8.90585 1.55207C9.18723 1.69236 9.43327 1.89441 9.62559 2.14314C9.81791 2.39187 9.95153 2.68085 10.0165 2.98848C10.0814 3.2961 10.076 3.61443 10.0007 3.91967Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Trabajá con nosotros
            </CTAButton>
          </BottomSection>
        </MenuContent>
      </Overlay>
    </>
  );
};

export default BurgerMenu;

/* ================= ESTILOS ================= */

const BurgerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;

  background-color: var(--primary-color);
  z-index: 2000;

  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;

  transform: ${({ $open }) =>
    $open ? "translateX(0)" : "translateX(100%)"};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  transition: transform 0.4s ease, visibility 0.4s ease;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 30px;
  right: 60px;
  font-size: 35px;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
`;

const MenuContent = styled.div`
  padding: 100px 40px 40px 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: white;
  min-height: 100%;
  box-sizing: border-box;


  @media (max-width: 380px) {
    padding: 70px 40px 40px 40px;
    gap: 20px;
  }
`;

const MenuItem = styled.a`
  font-size: 25px;
  font-weight: 500;
  color: var(--text-light);
  text-decoration: none;
  position: relative;

  &.active::before {
    content: "•";
    color: var(--secondary-color);
    position: absolute;
    left: -20px;
  }

  @media (min-width: 350px) and (max-width: 380px) {
    font-size: 21px;
  }
`;

const BottomSection = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 20px;

  @media (max-width: 350px) {
    margin-top: 50px;
    gap: 30px;
  }
`;

const Logo = styled.div`
  font-size: 20px;
  font-weight: 600;
  img {
    height: 30px;
  }
`;

const Socials = styled.div`
  display: flex;
  gap: 20px;
`;

const Circle = styled.a`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: white;
  color: var(--primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  text-decoration: none;

  svg {
    width: 18px;
    height: 18px;
  }
`;

const CTAButton = styled.a`
  background-color: var(--secondary-color);
  border: none;
  padding: 14px 20px;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: 12px;
  max-width: 265px;
  width: 100%;
  min-height: 50px;
  align-items: center;
  text-decoration: none;

  @media (min-width: 350px) and (max-width: 380px) {
    font-size: 15px;
  }
`;
const ContentLogoSocials = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;